import { createContext } from 'react';

var GContextInit = {
    IS_IN_ADMIN: false,
    loading: false,
    setLoading: (function () { }),
    userInfo: {},
    globalFlags: {},
    restData: {},
};
var GlobalContext = createContext(GContextInit);

export { GContextInit, GlobalContext };
